<template>
  <div class="cl-progress-bar-container">
    <div class="cl-progress-bar" v-bind:style="progressBarStyle">
      <div class="cl-progress" v-bind:style="progressStyle"></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'progress-bar',

    props: {
      value: {
        type: Number,
        default: 50,
      },
      bgColor: {
        type: String,
        default: '#00c896',
      },
      height: {
        type: Number,
        default: 10,
      },
      isBorderStyle: {
        type: Boolean,
        default: false,
      },
    },

    computed: {

      progressBarStyle() {
        return {
          height: `${this.height}px`,
          'border-bottom-left-radius': this.isBorderStyle ? '4px' : '',
          'border-bottom-right-radius': this.isBorderStyle ? '4px' : '',
        };
      },

      progressStyle() {
        return {
          width: `${this.value}%`,
          height: `${this.height}px`,
          'background-color': this.bgColor,
          'border-color': this.bgColor,
          'border-bottom-left-radius': this.isBorderStyle ? '4px' : '',
          'border-bottom-right-radius': () => {
            if (this.isBorderStyle && this.value === 100) {
              return '4px';
            }
            return '';
          },
        };
      },
    },

  };
</script>

<style lang="scss" scoped>
  .cl-progress-bar-container {
    position: relative;
    width: 100%;

    .cl-progress-bar {
      background-color: rgba(0, 0, 0, 0.05);
      z-index: 1;
      width: 100%;

      .cl-progress {
        z-index: 2;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// ProgressBar.vue?7d4ac81f